module.exports = __webpack_public_path__ + "static/DomainandOperationsSME-e94edb7bca268b83a7ac8f48eef65e67.png";